module.exports = __webpack_public_path__ + "static/media/process_1.a4f227b7.png";